import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    AfterViewInit,
    Output,
    EventEmitter,
    resolveForwardRef,
} from '@angular/core';
import * as Highcharts from 'highcharts';
import Chart from 'chart.js';
import { PortfolioService } from 'src/app/shared/services/portfolio.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';


@Component({
    selector: 'app-portfolio',
    templateUrl: './portfolio.component.html',
    styleUrls: ['./portfolio.component.scss'],
})
export class PortfolioComponent implements OnInit {
    // growth:Data
    pieOptions: any = {
        type: 'doughnut',
        options: {
            maintainAspectRatio: false,
            animation: {
                animateScale: true
            },
            cutoutPercentage: 70,
            legend: {
                display: true,
                position: 'right',
                align: 'start',
                usePointStyle: true,
                // labels: {
                //     // Point style of the legend box (only used if usePointStyle is true)

                //     // Rotation of the point in degrees (only used if usePointStyle is true)
                //     rotation: 100
                // }
            },
            tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                      return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
                    }
                }
            }
        }
    };
    lineOptions: any = {
        type: 'line',
        responsiveAnimationDuration: 0,
        backgroundColor: null,
        options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false,
            },
            tooltips: {
                mode: 'index',
                intersect: false,
                titleFontColor: '#ffffff',
                bodyFontColor: '#ffffff',
                titleFontSize: 15,
                bodyFontSize: '15',
                backgroundColor: '#293D4A',
                xPadding: 10,
                yPadding: 8,
                displayColors: false,
            },
            elements: {
                line: {
                    borderColor: '#22A4EF',
                    borderWidth: 1,
                    tension: 0,
                },
                point: {
                    radius: 1.5,
                },
            },
            scales: {
                yAxes: [
                    {
                        display: false,
                        gridLines: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                ],
                xAxes: [
                    {
                        display: true,
                        gridLines: {
                            display: true,
                            drawBorder: true,
                        },
                    },
                ],
            },
        },
    };
    portfolioGrowth: any;
    userProfile: {};
    userID: string;
    gradientFill = null;

    distributionData = {
        "id": "portfolio_24338197-62da-4ac8-a0c9-3204e396f9c7",
        "equity": 110045.62,
        "totalDrift": 0.0101,
        "rebalanceRequired": false,
        "nextPortfolioRebalance": "2018-12-11T15:00:00.846Z",
        "lastPortfolioRebalance": null,
        "holdings": [
            {
                "id": null,
                "type": "CASH_RESERVE",
                "name": null,
                "target": 0.11,
                "actual": 0.1,
                "value": 11001,
                "rebalanceRequired": false,
                "holdings": null
            },
            {
                "id": "fund_b567f1d3-486e-4e5f-aacd-0d551113ebf6",
                "type": "FUND",
                "name": "Funder BBB",
                "target": 0.3,
                "actual": 0.3054,
                "value": 33604.12,
                "rebalanceRequired": true,
                "holdings": [
                    {
                        "instrumentID": "5b85fabb-d57c-44e6-a7f6-a3efc760226c",
                        "symbol": "TSLA",
                        "target": 0.55,
                        "actual": 0.6823,
                        "openQty": 62.5213,
                        "value": 22928.9
                    },
                    {
                        "instrumentID": "a67422af-8504-43df-9e63-7361eb0bd99e",
                        "symbol": "AAPL",
                        "target": 0.45,
                        "actual": 0.3177,
                        "openQty": 62.4942,
                        "value": 10675.22
                    }
                ]
            },
            {
                "id": "fund_9a51b36f-faac-41a7-8c9d-b15bb29a05fc",
                "type": "FUND",
                "name": "Funder AAA",
                "target": 0.59,
                "actual": 0.5947,
                "value": 65440.5,
                "rebalanceRequired": true,
                "holdings": [
                    {
                        "instrumentID": "06926627-e950-48f3-9c53-b679f61120ec",
                        "symbol": "AMZN",
                        "target": 0.3,
                        "actual": 0.2595,
                        "openQty": 9.996,
                        "value": 16985.02
                    },
                    {
                        "instrumentID": "5b85fabb-d57c-44e6-a7f6-a3efc760226c",
                        "symbol": "TSLA",
                        "target": 0.5,
                        "actual": 0.6264,
                        "openQty": 111.7805,
                        "value": 40994.09
                    },
                    {
                        "instrumentID": "ca33741d-19e5-41fa-bf30-d303ec9c71be",
                        "symbol": "NVDA",
                        "target": 0.2,
                        "actual": 0.114,
                        "openQty": 49.2631,
                        "value": 7461.39
                    }
                ]
            }
        ]
    }

    // Title values
    firstName: string = ''
    // Top Card Values
    performanceData = {
        labels: [],
        values: []
    };
    portfolioValue: any = "0";
    investmentPlan: string = "0";
    portfolioPL: any = "0";
    portfolioPLpercentage: any = "0"
    riskLevel: string = "-";
    riskGrade: string = "-";


    toggle = '1W';

    activeMethod = 0;

    paymentMethods = [];
    holdings = [];

    distTotal: number;

    distData = {
        labels: [],
        values: []
    }
    emptyChart: boolean = false;
    errMsg: string;


              constructor(private api:PortfolioService,
              private SpinnerService: NgxSpinnerService,

                ) {
    }

    @ViewChild('performanceChart', { static: true }) distCanvas: ElementRef;
    @ViewChild('portfolioDistChart', { static: true }) chartCanvas: ElementRef;

    context: CanvasRenderingContext2D;

    ngOnInit() {
        this.SpinnerService.show();
        this.api.getProfile().subscribe((res:any) => {
           
            this.userID = res.data.id;
            this.getUserSettings(this.userID)
            this.populateTopCard('1w',this.userID);
            this.getPortfolio(this.userID);
            this.SpinnerService.hide();
        },err=>{
          this.SpinnerService.hide();
        })

        
        // this.getPositions();
    }

    populateTopCard(userID, period){
        this.api.fetchPerformance(period, userID).subscribe((res: any) =>{
            const performance = res.data.performance;
            const performanceLength = res.data.performance.length;
            this.resetGraph();
            if (performance){
                performance.forEach(element => {
                    this.performanceData.labels.push(element.date);
                    this.performanceData.values.push(element.unrealizedDayPL);
                    // performance % calculation
                });
                this.updateLineGraph(this.performanceData);
                // Portfolio Summation
                if(performance){
                    const todaysPerformance = performance[performanceLength - 1];
                    // console.log(todaysPerformance);
                    const portfolioBase =  todaysPerformance.deposits - todaysPerformance.withdrawals;
                    this.portfolioValue = todaysPerformance.equity + todaysPerformance.cash
                    this.portfolioValue = parseFloat(this.portfolioValue.toFixed(2))
                    this.portfolioPL = todaysPerformance.unrealizedDayPL || 0;
                    if(portfolioBase){
                        this.portfolioPLpercentage = (this.portfolioPL / portfolioBase) * 100;
                        this.portfolioPLpercentage = parseFloat(this.portfolioPLpercentage.toFixed(2));
                        this.portfolioPL = parseFloat(this.portfolioPL.toFixed(2))
                    } else {
                        this.portfolioPLpercentage = 0
                    }
                }
            }
        });
    }

    resetGraph(){
        this.performanceData = {
            labels: [],
            values: []
        };
    }

    graphToggle(period) {
       if(period){
           this.resetGraph()
           this.populateTopCard(period.toLowerCase(), this.userID);
       }
    }

    wrapDistributionData(data) {
        this.holdings = data.holdings;
        // console.log(this.holdings,'hold');
        this.distTotal = data.equity;
        this.holdings.forEach(holding => {
            this.paymentMethods.push({
                title: holding.name,
                total: holding.value,
                id: holding.id
            });
            if(holding.holdings){
                const portfolioEquity = holding.holdings;

                holding.holdings.forEach(equity => {
                    equity.pL = 0;
                    equity.pLPercentage = 0;
                });

            }
            const percentage = ((holding.value/this.distTotal ) * 100).toFixed(2)|| 0;

            this.distData.labels.push(holding.name);
            this.distData.values.push(percentage);
        });

    }

    getUserSettings(userID){
        this.api.getSettings(userID).subscribe((res:any)=>{
            this.investmentPlan = res.data.portfolioType.split(" ")
                                        .map(
                                            ([firstChar,...rest])=>firstChar
                                                .toUpperCase()+rest
                                                    .join("")
                                                        .toLowerCase())
                                                            .join(" ");
            this.userProfile = res.data;
        });
    }

    fetchGraphData(period){
        this.resetGraph();
        this.api.fetchPerformance(period, this.userID).subscribe((res: any) =>{
            const performance = res.data.performance;
            if (performance){
                performance.forEach(element => {
                    this.performanceData.labels.push(element.date);
                    this.performanceData.values.push(element.unrealizedDayPL);
                    // performance % calculation
                });
                this.updateLineGraph(this.performanceData);
            }

        });
    }

    updateLineGraph(data) {
        const ctx = (<HTMLCanvasElement>this.distCanvas.nativeElement).getContext(
            '2d'
        );

        this.gradientFill = ctx.createLinearGradient(1, 0, 0, 270);
        this.gradientFill.addColorStop(0, 'rgba(229, 244, 253, 1)');
        this.gradientFill.addColorStop(0.35, 'rgba(176, 221, 248, 0)');
        this.gradientFill.addColorStop(0.47, 'rgba(229, 244, 253, 0)');

        this.gradientFill.addColorStop(1, 'rgba(255, 255, 255, 0)');

        this.portfolioGrowth = new Chart(ctx, {
            ...this.lineOptions,
            data: {
                labels: data.labels,
                datasets: [
                    {
                        data: data.values,
                        fill: true,
                        lineTension: 0,
                        backgroundColor: this.gradientFill,
                        hoverBackgroundColor: this.gradientFill,
                        borderColor: '#1178B9',
                        borderWidth: 1,
                        showLine: true,
                        pointHoverRadius: 6,
                    },
                ],
            },
        });
    }
    updateDoughnutGraph(data){
        const ctx = (<HTMLCanvasElement>this.chartCanvas.nativeElement).getContext(
            '2d'
        );

        this.portfolioGrowth = new Chart(ctx, {
            ...this.pieOptions,
            data: {
                labels: data.labels,
                datasets: [
                    {
                        data: data.values,
                        backgroundColor:['#B8DCFB', '#ABDFC7', '#FFC893'],
                        borderWidth: 3,
                    },
                ],
            },
        });
    }

    toggleAccordion(id) {
        if (this.activeMethod === id) this.activeMethod = 0;
        else {
            this.activeMethod = id;
        }
    }

    // get user portfolio
    getPortfolio(userId){
        this.SpinnerService.show()
        this.api.portfolio(userId)
            .subscribe((res:any)=>{
                if(res){
                    this.wrapDistributionData(res.data);
                    // Calculate percentage
                    this.updateDoughnutGraph(this.distData);
                }
               else
               this.emptyChart = true
                this.SpinnerService.hide();
            },err=>{
                this.SpinnerService.hide();
                this.errMsg = err.error;
              
            })
    }

    getPositions(){
        this.api.positions()
            .subscribe((res:any)=>{
               const position =res
            })
    }
}
